import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const session_id = match[1];
    api.post("/auth/google/session", { session_id })
      .then(({ data }) => {
        setUser(data);
        // Clean up hash
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard");
      })
      .catch(() => nav("/login"));
  }, [nav, setUser]);

  return (
    <main className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-zinc-600">
        <Loader2 className="animate-spin text-[#009A44]" size={22} /> Signing you in…
      </div>
    </main>
  );
}
